import {AlertItem, CountItem} from '../typedef';

import {mergeSavedContentData} from './merge-saved-content-data';

type SearchItem = {
    id: string | number,
    name: string,
    searchType: string,
    auditStatistic?: {
        createdAt?: string,
        lastRunAt?: string,
        lastSharedAt?: string,
        lastUpdatedAt?: string,
    },
};


export const mergeSavedSearchesData = (searchesArray: SearchItem[], alerts: AlertItem[], countsData: CountItem[]) => {
    return mergeSavedContentData(
        searchesArray,
        alerts,
        countsData,
        {
            getId: (item: SearchItem) => item.id,
            getName: (item: SearchItem) => item.name,
            getSearchType: (item: SearchItem) => item.searchType,
            getAuditStatistic: (item: SearchItem) => item.auditStatistic,
            getCountKey: (count: CountItem) => count.savedSearchId,
            getCountValues: (count: CountItem) => ({alertCount: count.alertCount, totalCount: count.searchTotalCount}),
        },
    );
};
